




































































import Vue from "vue";
import { Manuscript, ManuscriptSetting } from "@/lib/models";
import RadioIcon from "@/components/atoms/RadioIcon.vue";
import CheckboxIcon from "@/components/atoms/CheckboxIcon.vue";
import { Dialog } from "@/lib/utils";
import DialogVue from "@/components/ui/Dialog.vue";
import MaskedLoading from "@/components/atoms/MaskedLoading.vue";
import axiosBase from "axios";

const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_IMAGE_DOWNLOAD_API_ENDPOINT,
  headers: { "Content-Type": "application/json" },
});

const WritingFormat = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
} as const;
type WritingFormat = typeof WritingFormat[keyof typeof WritingFormat];

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { RadioIcon, CheckboxIcon, MaskedLoading },
  props: {
    novelId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedManuscripts: [],
      selectedFormat: WritingFormat.VERTICAL,
      selectedShowTitle: true,
      checkBoxColor: "#707070",
      isDownloading: false,
    };
  },
  methods: {
    onClickOutSide() {
      this.$close(true);
    },
    onChangeFormat(format) {
      this.selectedFormat = format;
    },
    onChangeShowTitle(showTitle) {
      this.selectedShowTitle = showTitle;
    },
    onClickManuscript(manuscript) {
      const { selectedManuscripts } = this;
      if (selectedManuscripts.some((x) => x.key === manuscript.key)) {
        this.selectedManuscripts = selectedManuscripts.filter((x) => x.key !== manuscript.key);
      } else {
        this.selectedManuscripts.push(manuscript);
      }
    },
    async onClickDonwload() {
      this.isDownloading = true;

      try {
        const manuscripts = this.selectedManuscripts as Manuscript[];
        const format = this.selectedFormat as WritingFormat;
        const showTitle = this.selectedShowTitle as boolean;
        const manuscriptSetting = this.manuscriptSetting as ManuscriptSetting;
        const response = await axios.post("/exportManuscriptPdf", {
          manuscripts,
          format,
          showTitle,
          manuscriptSetting,
        });

        /** PDFをダウンロード */
        const url = URL.createObjectURL(this.base64ToBlob(response.data));
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.download = `${this.novelId}.pdf`;
        a.href = url;
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        const confirmDialog = new Dialog(DialogVue);
        const options = {
          title: "エラー",
          content: e,
        };
        confirmDialog.show(options);
      } finally {
        this.isDownloading = false;
      }
    },
    base64ToBlob(base64: string) {
      /** 日本語対応 */
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);

      const uint8Array = Buffer.from(base64, "base64");
      return new Blob([bom, uint8Array.buffer], {
        type: "application/pdf",
      });
    },
  },
  computed: {
    manuscriptList() {
      return this.$store.getters["manuscriptModule/manuscriptList"];
    },
    manuscriptSetting() {
      return this.$store.getters["novelModule/manuscriptSetting"](this.novelId) as ManuscriptSetting;
    },
    isChecked() {
      return (manuscript) => {
        const { selectedManuscripts } = this;
        return selectedManuscripts.some((x) => x.key === manuscript.key);
      };
    },
    orderNumber() {
      return (manuscript) => {
        const { selectedManuscripts } = this;
        return selectedManuscripts.findIndex((x) => x.key === manuscript.key) + 1;
      };
    },
  },
});

interface Props {
  novelId: string;
}

interface Data {
  selectedManuscripts: Manuscript[];
  selectedFormat: WritingFormat;
  checkBoxColor: string;
}

interface Methods {
  onClickOutSide: () => void;
  onChangeFormat(format: WritingFormat): void;
  onChangeShowTitle(showTitle: boolean): void;
  onClickManuscript(manuscript: Manuscript): void;
  onClickDonwload(): void;
  base64ToBlob(base64: string): Blob;
}

interface Computed {
  manuscriptList: Manuscript[];
  manuscriptSetting: ManuscriptSetting;
  isChecked(manuscript: Manuscript): boolean;
  orderNumber(manuscript: Manuscript): number;
}

export type ExportManuscriptPdfDialogProps = Props;
